export const site = {
    gtmId: 'GTM-PDG49BP',
    name: 'LoanDO',
    title: 'loando.ro',
    separator: ' | ',
    url: 'https://loando.ro',
    lang: {
        head: 'ro',
        meta: 'ro',
    },
    hreflang: [
        { url: 'https://loando.pl', lang: 'pl' },
        { url: 'https://loando.ro', lang: 'ro' },
        { url: 'https://loando.cz', lang: 'cs' },
        { url: 'https://loando.mx', lang: 'es-mx' },
        { url: 'https://loando.ua', lang: 'uk' },
        { url: 'https://loando.ua/ru', lang: 'ru-ua' },
    ],
};
